import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import api from "../../../api";

export default function Cos_reg() {
  const location = useLocation();
  const [coCount, setCoCount] = useState(location.state?.co_count || 0);
  const { usercourse_id } = location.state;
  const [formData, setFormData] = useState(
    Array.from({ length: coCount }, (_, index) => ({
      cos_name: `CO${index + 1}`,
      cos_body: "",
    }))
  );

  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  // Handle co_count change and adjust formData accordingly
  const handleCoCountChange = (e) => {
    const value = e.target.value;
    const newCount = value === "" ? "" : Math.min(Math.max(parseInt(value), 1), 10);
  
    setCoCount(newCount);
  
    if (newCount > formData.length) {
      // Add new fields if count increases
      const newFields = Array.from(
        { length: newCount - formData.length },
        (_, index) => ({
          cos_name: `CO${formData.length + index + 1}`,
          cos_body: "",
        })
      );
      setFormData([...formData, ...newFields]);
    } else if (newCount !== "") {
      // Remove extra fields if count decreases
      setFormData(formData.slice(0, newCount));
    }
  };
  
  
  // Handle input field change
  const handleChange = (index, e) => {
    const { name, value } = e.target;
    const updatedFormData = [...formData];
    updatedFormData[index] = { ...updatedFormData[index], [name]: value };
    setFormData(updatedFormData);
  };

  // Handle form submission
  const handleSubmit = async () => {
    try {
      setLoading(true);
      console.log(formData)
      const response = await api.post("/api/cos/add", { formData, usercourse_id });
      console.log("Successfully added COS records:", response.data);
      setSuccessMessage(response.data.message || "COS records added successfully!");
      setErrorMessage("");
    } catch (error) {
      if (error.response && error.response.data) {
        setErrorMessage(error.response.data.error || "An unknown error occurred.");
      } else {
        setErrorMessage("There was an error saving the COS records. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="left-0 z-45 w-full mt-8">
      <div className="max-w-screen-md mx-auto p-6 border border-gray-300 shadow-lg rounded-md bg-white mt-10">
        <h1 className="text-2xl mb-6 text-blue-500 text-center">COS Form</h1>

        {errorMessage && <div className="mb-4 text-red-500">{errorMessage}</div>}
        {successMessage && <div className="mb-4 text-green-500">{successMessage}</div>}

        {/* Editable CO Count */}
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">CO Count</label>
          <input
            type="text"
            value={(coCount)}
            onChange={handleCoCountChange}
            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
            min={1}
          />
        </div>

        <form className="space-y-4">
          {formData.map((cos, index) => (
            <div key={index} className="flex flex-wrap -mx-2 mb-4 justify-center">
              <div className="w-full sm:w-1/2 px-3">
                <label
                  htmlFor={`cos_name_${index}`}
                  className="block text-sm font-medium text-gray-700"
                  style={{ textTransform: "uppercase" }}
                >
                  COS Name
                </label>
                <input
                  type="text"
                  id={`cos_name_${index}`}
                  name="cos_name"
                  value={cos.cos_name}
                  onChange={(e) => handleChange(index, e)}
                  className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                  style={{ textTransform: "uppercase" }}
                />
              </div>

              <div className="w-full sm:w-1/2 px-3">
                <label htmlFor={`cos_body_${index}`} className="block text-sm font-medium text-gray-700">
                  COS Body
                </label>
                <input
                  type="text"
                  id={`cos_body_${index}`}
                  name="cos_body"
                  value={cos.cos_body}
                  onChange={(e) => handleChange(index, e)}
                  className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                />
              </div>
            </div>
          ))}

          <button
            type="button"
            onClick={handleSubmit}
            className="w-70 bg-blue-500 text-white py-2 px-4 rounded-md mt-6"
          >
            {loading ? "Submitting..." : "Submit"}
          </button>
        </form>
      </div>
    </div>
  );
}
